export const TAG_PER_PAGE_MAX = 20;
